module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center4"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("“O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCE UPON A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("IS TIMELESS WITH THESE RETOLD TALES:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Beauty Sleep: A Retelling of “Sleeping Beauty”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Cameron Dokey")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Midnight Pearls: A Retelling of “The Little Mermaid”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Debbie Viguié")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Snow: A Retelling of “Snow White and the Seven Dwarfs”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Tracy Lynn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Water Song:")]), _vm._v(" A "), _c('em', [_vm._v("Retelling of “The Frog Prince”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Suzanne Weyn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Before Midnight:")]), _vm._v(" A "), _c('em', [_vm._v("Retelling of “Cinderella”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Cameron Dokey")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Storyteller’s Daughter:")]), _vm._v(" A "), _c('em', [_vm._v("Retelling of"), _c('br'), _vm._v("“The Arabian Nights”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Cameron Dokey")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Golden: A Retelling of “Rapunzel”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("By Cameron Dokey")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf76d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 60
// module chunks = 0